// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iUo7FylbowNXt_iBSqhl{padding-bottom:15px !important}`, "",{"version":3,"sources":["webpack://./ui-kit/FieldsFilterSelector/FieldsFilterSelector.module.scss"],"names":[],"mappings":"AAAA,sBACI,8BAAA","sourcesContent":[".checkbox-item {\r\n    padding-bottom: 15px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-item": `iUo7FylbowNXt_iBSqhl`
};
export default ___CSS_LOADER_EXPORT___;
